/* Colby + wetsuit guide: suit finder, temperature chart, size helper and collection tabs.
   Each section carries its own data in <script type="application/json" data-cg-data> (products)
   and data-cg-chart (size chart), rendered by snippets/colby-guide-data and colby-size-chart. */
(function () {
  var ORDER = ['XS', 'S', 'ST', 'MS', 'M', 'MT', 'LS', 'L', 'LT', 'XLS', 'XL', 'XLT', 'XXL'];
  var LINES = { greenwave: 'Greenwave', yamamoto: 'Colby + Yamamoto', white_label: 'White Label' };
  var PHONE = '(805) 702-1818';

  function json(root, attr) {
    var el = root.querySelector('script[' + attr + ']');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function c(f) { return Math.round((f - 32) * 5 / 9); }
  function money(cents) { return '$' + (cents % 100 ? (cents / 100).toFixed(2) : cents / 100); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function ft(i) { return Math.floor(i / 12) + '′' + (i % 12) + '″'; }
  function size(p, z) { for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].n === z) return p.sizes[i]; return null; }
  function has(p, z) { var s = size(p, z); return !!(s && s.a); }
  function live(p) { return p.sizes.filter(function (s) { return s.a; }); }
  function fits(p, e) { return e >= p.lo && (p.hi === null || e <= p.hi); }
  function mid(p) { return (p.lo + (p.hi === null ? p.lo + 10 : p.hi)) / 2; }

  // Size chart lookup. Between two sizes, take the taller one (Colby + fit advice).
  // Outside every range, return null: the surfer should call rather than get a guess.
  function chartSize(chart, h, w) {
    var hits = chart.filter(function (r) { return h >= r[1] && h <= r[2] && w >= r[3] && w <= r[4]; });
    if (!hits.length) return null;
    hits.sort(function (a, b) { return b[2] - a[2]; });
    return { z: hits[0][0], between: hits.length > 1 };
  }

  function fillHeights(sel, def) {
    for (var i = 62; i <= 78; i++) {
      var o = document.createElement('option');
      o.value = i; o.textContent = ft(i); if (i === def) o.selected = true;
      sel.appendChild(o);
    }
  }

  /* Suit finder */
  function initFinder(root) {
    var P = json(root, 'data-cg-data') || [];
    var copy = json(root, 'data-cg-copy') || {};
    var st = { t: 56, run: 0, col: 'yamamoto', sz: '' };
    var out = root.querySelector('[data-cg-out]');
    var sel = root.querySelector('[data-cg-size]');
    ORDER.forEach(function (z) { var o = document.createElement('option'); o.textContent = z; sel.appendChild(o); });

    function pick(col, e) {
      var cs = P.filter(function (p) { return p.line === col && fits(p, e); });
      // Prefer a suit stocked in the chosen size, then the band centred closest to the water.
      cs.sort(function (a, b) {
        var sa = st.sz && !has(a, st.sz), sb = st.sz && !has(b, st.sz);
        if (sa !== sb) return sa ? 1 : -1;
        return Math.abs(mid(a) - e) - Math.abs(mid(b) - e);
      });
      return cs[0] || null;
    }

    // "Why this suit": where the water sits in the rating, cusp advice that follows how you run,
    // how the collection feels, and buttons to compare the other collections.
    function whyBox(p, e) {
      var range = p.lo + (p.hi === null ? '°F and up' : '–' + p.hi + '°F');
      var where = e - p.lo <= 2 ? 'cold' : (p.hi !== null && p.hi - e <= 2 ? 'warm' : 'mid');
      var same = P.filter(function (q) { return q !== p && q.line === p.line && q.thk !== p.thk && fits(q, e); });
      var warmer = same.filter(function (q) { return q.lo < p.lo; }).sort(function (a, b) { return a.lo - b.lo; })[0];
      var lighter = same.filter(function (q) { return q.hi !== null && p.hi !== null && q.hi > p.hi; }).sort(function (a, b) { return b.hi - a.hi; })[0];
      var h = '<p class="cg-why"><strong>Rated ' + range + '.</strong> ' +
        (st.run ? 'You run ' + (st.run < 0 ? 'cold' : 'warm') + ', so we treated ' + st.t + '°F water like ' + e + '°F. ' : '') +
        (where === 'mid' ? 'That sits comfortably inside this suit’s range.' : where === 'cold' ? 'That’s the cold end of this suit’s range.' : 'That’s the warm end of this suit’s range.') + '</p>';
      if (where === 'cold' && warmer) h += '<p class="cg-why"><strong>On the cusp?</strong> ' + (st.run < 0 ? 'Since you run cold, ' : 'If you run cold, ') + 'the <a href="' + warmer.url + '">' + esc(warmer.thk) + '</a> gives you more margin.</p>';
      else if (where === 'warm' && lighter) h += '<p class="cg-why"><strong>On the cusp?</strong> ' + (st.run > 0 ? 'Since you run warm, ' : 'If you run warm, ') + 'the lighter <a href="' + lighter.url + '">' + esc(lighter.thk) + '</a> also works here.</p>';
      if (st.run < 0) h += '<p class="cg-why"><strong>Running cold:</strong> between two suits, take the warmer one.</p>';
      if (st.run > 0) h += '<p class="cg-why"><strong>Running warm:</strong> between two suits, take the lighter one for more freedom on the paddle.</p>';
      if (e < 55 && p.thk.indexOf('hood') < 0) h += '<p class="cg-why"><strong>Add a hood or balaclava</strong> ' + (st.run < 0 ? 'since you run cold' : 'below 55°F if you duck-dive a lot') + '.</p>';
      if (e < 52) h += '<p class="cg-why"><strong>Add boots.</strong> Our Tech-Tailored bootie is built from your foot scan.</p>';
      if (copy[p.line]) h += '<p class="cg-why"><strong>Why ' + LINES[p.line] + ':</strong> ' + esc(copy[p.line]) + '</p>';
      var others = ['greenwave', 'yamamoto', 'white_label'].filter(function (k) { return k !== p.line && pick(k, e); });
      if (others.length) h += '<p class="cg-why">At the same thickness, every collection is rated for similar water. They differ in feel and price. Compare:</p><div class="cg-chips">' +
        others.map(function (k) { return '<button type="button" class="cg-chip" data-cg-pick-line="' + k + '">' + LINES[k] + '</button>'; }).join('') + '</div>';
      if (copy.link) h += '<p class="cg-why"><a href="' + esc(copy.link) + (copy.link.indexOf('?') < 0 ? '?' : '&') + 'collection=' + p.line + '">' + esc(copy.label || 'Why it feels different') + ' →</a></p>';
      return '<div class="cg-whybox"><span class="cg-lab">Why this suit</span>' + h + '</div>';
    }

    function render() {
      var e = st.t + st.run, note = '';
      root.querySelector('[data-cg-tf]').textContent = st.t;
      root.querySelector('[data-cg-tc]').textContent = c(st.t) + '°C';
      var p = pick(st.col, e);
      if (!p) {
        var other = ['yamamoto', 'white_label', 'greenwave'].map(function (k) { return pick(k, e); }).filter(Boolean)[0];
        if (!other) {
          out.innerHTML = '<div class="cg-eyebrow">No suit for this water</div><h3 style="margin:6px 0">Colder than any published range</h3><p class="cg-why">Our coldest suits are rated to the mid 40s °F (7°C). Below that, call us before you buy: <a href="tel:+18057021818">' + PHONE + '</a>.</p>';
          return;
        }
        note = '<div class="cg-flag" style="margin:0 0 14px"><b>' + LINES[st.col] + '</b> doesn’t make a suit for ' + st.t + '°F water' + (st.run ? ' the way you run' : '') + '. Closest match from ' + LINES[other.line] + ':</div>';
        p = other;
      }
      var mine = st.sz, avail = live(p), ok = mine ? has(p, mine) : avail.length > 0;
      var chips = ORDER.filter(function (z) { return size(p, z); }).map(function (z) {
        return '<span class="' + (has(p, z) ? '' : 'is-out ') + (z === mine ? 'is-me' : '') + '">' + z + '</span>';
      }).join('');
      var cta = ok
        ? '<a class="cg-btn cg-btn--block" style="margin-top:14px" href="' + p.url + (mine && size(p, mine) ? '?variant=' + size(p, mine).id : '') + '">View suit' + (mine ? ' · ' + mine + ' in stock' : '') + '</a>'
        : '<div class="cg-flag"><b>' + (mine && avail.length ? mine + ' is sold out' : 'Sold out in every size') + '.</b> Get notified on the product page.</div><a class="cg-btn cg-btn--ghost cg-btn--block" style="margin-top:10px" href="' + p.url + '">Get restock alerts</a>';
      out.innerHTML = note +
        '<div class="cg-eyebrow">Recommended for ' + e + '°F · ' + c(e) + '°C' + (st.run ? ' (adjusted)' : '') + '</div>' +
        '<div class="cg-rec"><div class="cg-ph">' + (p.img ? '<img src="' + p.img + '" alt="' + esc(p.t) + '" loading="lazy">' : '') + '</div><div>' +
        '<h3>' + esc(p.t) + '</h3><div class="cg-price" style="margin-top:4px">' + money(p.price) + '</div>' +
        '<p class="cg-why">“Typically used in water temps in the ' + esc(p.txt) + '.”</p>' +
        (p.wt ? '<p class="cg-why">Thermal lining adds weight on this suit.</p>' : '') +
        '</div></div><span class="cg-lab">Stock by size</span><div class="cg-sizes">' + chips + '</div>' + cta + whyBox(p, e);
    }

    function seg(name, v) {
      root.querySelectorAll('[data-cg-seg="' + name + '"] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === String(v))); });
      st[name] = name === 'run' ? +v : v; render();
    }
    root.querySelectorAll('[data-cg-seg]').forEach(function (g) {
      g.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) seg(g.dataset.cgSeg, b.dataset.v); });
    });
    root.querySelector('input[type=range]').addEventListener('input', function (e) { st.t = +e.target.value; render(); });
    sel.addEventListener('change', function () { st.sz = sel.value; render(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cg-pick-line]');
      if (a) seg('col', a.dataset.cgPickLine);
    });
    render();
  }

  /* Temperature chart: one row per thickness, one lane per collection. Tapping the key highlights a collection. */
  function initBands(root) {
    var P = json(root, 'data-cg-data') || [];
    var MIN = 40, MAX = 76, KEYS = ['greenwave', 'yamamoto', 'white_label'];
    var LABEL = { spring: 'Spring', '3/2': '3/2', '3mm hooded': '3mm hood', '4/3': '4/3', '4/3 hooded': '4/3 hood', '5/4 hooded': '5/4 hood' };
    function pc(v) { return (Math.max(MIN, Math.min(MAX, v)) - MIN) / (MAX - MIN) * 100; }
    var scale = root.querySelector('[data-cg-scale]'), bands = root.querySelector('[data-cg-bands]');
    [40, 45, 50, 55, 60, 65, 70, 75].forEach(function (v) { scale.insertAdjacentHTML('beforeend', '<span class="' + (v % 10 ? 'cg-odd' : '') + '" style="left:' + pc(v) + '%">' + v + '°</span>'); });
    ['spring', '3/2', '3mm hooded', '4/3', '4/3 hooded', '5/4 hooded'].forEach(function (g) {
      var rows = P.filter(function (p) { return p.thk === g; });
      if (!rows.length) return;
      var lanes = KEYS.map(function (k) {
        var seen = {}, bars = '';
        rows.filter(function (p) { return p.line === k; }).forEach(function (p) {
          var id = p.lo + '-' + p.hi; if (seen[id]) return; seen[id] = 1;
          var hi = p.hi === null ? MAX : p.hi, open = p.hi === null;
          var lab = LINES[k] + ' ' + g + ': ' + p.lo + (open ? '°F and up' : '–' + p.hi + '°F') + ' (' + c(p.lo) + (open ? '°C and up' : '–' + c(p.hi) + '°C') + ')';
          bars += '<a href="' + p.url + '" class="cg-c-' + k + (open ? ' is-open' : '') + '" style="left:' + pc(p.lo) + '%;width:' + (pc(hi) - pc(p.lo)) + '%" title="' + esc(lab) + '" aria-label="' + esc(lab) + '"></a>';
        });
        return '<div class="cg-lane" data-line="' + k + '">' + bars + '</div>';
      }).join('');
      bands.insertAdjacentHTML('beforeend', '<div class="cg-brow"><div class="cg-brow__nm">' + LABEL[g] + '</div><div class="cg-track">' + lanes + '</div></div>');
    });
    var on = '';
    root.querySelectorAll('[data-cg-key]').forEach(function (b) {
      b.addEventListener('click', function () {
        on = on === b.dataset.cgKey ? '' : b.dataset.cgKey;
        root.querySelectorAll('[data-cg-key]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.cgKey === on)); });
        root.classList.toggle('is-filtered', !!on);
        root.querySelectorAll('.cg-lane').forEach(function (l) { l.classList.toggle('is-on', l.dataset.line === on); });
      });
    });
  }

  /* Collection tabs (wetsuit technology page). ?collection=greenwave or #greenwave opens that tab. */
  function initTabs(root) {
    var btns = root.querySelectorAll('[data-cg-tab]');
    if (!btns.length) return;
    function show(k) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.cgTab === k)); b.tabIndex = b.dataset.cgTab === k ? 0 : -1; });
      root.querySelectorAll('[data-cg-for]').forEach(function (ch) { var f = ch.dataset.cgFor; ch.hidden = !(f === 'all' || f === k); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.cgTab); }); });
    var want = (location.search.match(/[?&]collection=([a-z_]+)/) || [])[1] || location.hash.slice(1);
    var ok = Array.prototype.some.call(btns, function (b) { return b.dataset.cgTab === want; });
    show(ok ? want : btns[0].dataset.cgTab);
  }

  /* Size helper (Find Your Fit page and product pages) */
  function initSize(root) {
    var chart = json(root, 'data-cg-chart') || [];
    var hs = root.querySelector('[data-cg-h]'), ws = root.querySelector('[data-cg-w]'), out = root.querySelector('[data-cg-size-out]');
    var stock = json(root, 'data-cg-stock'); // product page only: {"M":true,...}
    fillHeights(hs, +(hs.dataset.default || 70));
    function run() {
      var r = chartSize(chart, +hs.value, +ws.value);
      // Size chart page: highlight the matching cell in the grid.
      document.querySelectorAll('[data-cg-cell]').forEach(function (c) { c.classList.toggle('is-on', !!r && c.dataset.cgCell === r.z); });
      if (!r) { out.innerHTML = 'Outside our size chart. Call us at <a href="tel:+18057021818">' + PHONE + '</a> and we’ll find your fit.'; return; }
      var msg = 'Colby + size chart: <strong>' + r.z + '</strong>' + (r.between ? ' — between sizes, so the taller one' : '') + '.';
      if (stock) {
        if (!(r.z in stock)) msg += ' This suit doesn’t come in ' + r.z + '.';
        else if (stock[r.z]) msg += '<br><button type="button" data-cg-select="' + r.z + '">Select ' + r.z + '</button>';
        else msg += ' <strong>Sold out in this suit</strong> — sign up for a restock alert below.';
      } else {
        var link = root.dataset.shopUrl;
        if (link) msg += '<br><a class="cg-btn" style="margin-top:12px" href="' + link + '">Shop suits</a>';
      }
      out.innerHTML = msg;
    }
    hs.addEventListener('change', run); ws.addEventListener('input', run);
    out.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cg-select]'); if (!b) return;
      var z = b.dataset.cgSelect;
      var input = document.querySelector('variant-selects input[type=radio][value="' + z + '"], variant-radios input[type=radio][value="' + z + '"]');
      if (input) { input.click(); input.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      else {
        var s = document.querySelector('variant-selects select');
        if (s) { s.value = z; s.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
    run();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cg]').forEach(function (el) {
      if (el.dataset.cgReady) return; el.dataset.cgReady = '1';
      var k = el.dataset.cg;
      if (k === 'finder') initFinder(el);
      else if (k === 'bands') initBands(el);
      else if (k === 'size') initSize(el);
      else if (k === 'tabs') initTabs(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
